export default __webpack_public_path__ + "static/everton-93ec6bd22ac004f1942526de0eb4a26e.jpg";